{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "echarts_option",
  "description": "ECharts option object — passed directly to echarts.setOption()",
  "type": "object",
  "additionalProperties": true,
  "properties": {
    "title": {
      "oneOf": [
        { "$ref": "#/$defs/title" },
        { "type": "array", "items": { "$ref": "#/$defs/title" } }
      ]
    },
    "grid": {
      "oneOf": [
        { "$ref": "#/$defs/grid" },
        { "type": "array", "items": { "$ref": "#/$defs/grid" } }
      ]
    },
    "xAxis": {
      "oneOf": [
        { "$ref": "#/$defs/axis" },
        { "type": "array", "items": { "$ref": "#/$defs/axis" } }
      ]
    },
    "yAxis": {
      "oneOf": [
        { "$ref": "#/$defs/axis" },
        { "type": "array", "items": { "$ref": "#/$defs/axis" } }
      ]
    },
    "tooltip": { "$ref": "#/$defs/tooltip" },
    "legend": { "$ref": "#/$defs/legend" },
    "color": {
      "type": "array",
      "items": { "type": "string" }
    },
    "series": {
      "type": "array",
      "items": { "$ref": "#/$defs/series_item" }
    },
    "animation": { "type": "boolean" },
    "animationDuration": { "type": "number" },
    "animationEasing": { "type": "string" },
    "backgroundColor": { "type": "string" },
    "textStyle": { "$ref": "#/$defs/text_style" },
    "visualMap": {
      "oneOf": [
        { "$ref": "#/$defs/visual_map" },
        { "type": "array", "items": { "$ref": "#/$defs/visual_map" } }
      ]
    },
    "dataZoom": {
      "type": "array",
      "items": { "$ref": "#/$defs/data_zoom" }
    },
    "toolbox": { "$ref": "#/$defs/toolbox" },
    "radar": { "$ref": "#/$defs/radar" }
  },
  "$defs": {
    "title": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "text": { "type": "string" },
        "subtext": { "type": "string" },
        "show": { "type": "boolean" },
        "left": {},
        "top": {},
        "right": {},
        "bottom": {},
        "textStyle": { "$ref": "#/$defs/text_style" },
        "subtextStyle": { "$ref": "#/$defs/text_style" }
      }
    },
    "grid": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "left": {},
        "right": {},
        "top": {},
        "bottom": {},
        "width": {},
        "height": {},
        "containLabel": { "type": "boolean" },
        "show": { "type": "boolean" },
        "backgroundColor": { "type": "string" },
        "borderColor": { "type": "string" },
        "borderWidth": { "type": "number" }
      }
    },
    "axis": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["value", "category", "time", "log"]
        },
        "name": { "type": "string" },
        "nameLocation": {
          "type": "string",
          "enum": ["start", "middle", "center", "end"]
        },
        "nameTextStyle": { "$ref": "#/$defs/text_style" },
        "nameGap": { "type": "number" },
        "min": {},
        "max": {},
        "data": { "type": "array" },
        "show": { "type": "boolean" },
        "inverse": { "type": "boolean" },
        "boundaryGap": {},
        "splitNumber": { "type": "number" },
        "splitLine": { "$ref": "#/$defs/line_style_wrapper" },
        "splitArea": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" }
          }
        },
        "axisLine": { "$ref": "#/$defs/line_style_wrapper" },
        "axisTick": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" }
          }
        },
        "axisLabel": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" },
            "rotate": { "type": "number" },
            "formatter": { "type": "string" },
            "fontSize": { "type": "number" },
            "color": { "type": "string" },
            "interval": {}
          }
        },
        "interval": { "type": "number" },
        "axisPointer": {
          "type": "object",
          "additionalProperties": true
        },
        "position": {}
      }
    },
    "tooltip": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "trigger": {
          "type": "string",
          "enum": ["item", "axis", "none"]
        },
        "axisPointer": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "type": {
              "type": "string",
              "enum": ["line", "shadow", "cross", "none"]
            }
          }
        },
        "formatter": { "type": "string" },
        "backgroundColor": { "type": "string" },
        "borderColor": { "type": "string" },
        "textStyle": { "$ref": "#/$defs/text_style" }
      }
    },
    "legend": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "data": { "type": "array" },
        "orient": {
          "type": "string",
          "enum": ["horizontal", "vertical"]
        },
        "left": {},
        "top": {},
        "right": {},
        "bottom": {},
        "textStyle": { "$ref": "#/$defs/text_style" },
        "type": {
          "type": "string",
          "enum": ["plain", "scroll"]
        }
      }
    },
    "series_item": {
      "type": "object",
      "required": ["type"],
      "additionalProperties": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["bar", "line", "scatter", "tree", "graph"]
        },
        "name": { "type": "string" },
        "data": { "type": "array" },
        "stack": { "type": "string" },
        "smooth": { "type": "boolean" },
        "areaStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "opacity": { "type": "number" }
          }
        },
        "itemStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "borderColor": { "type": "string" },
            "borderWidth": { "type": "number" },
            "borderRadius": {},
            "opacity": { "type": "number" }
          }
        },
        "lineStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "width": { "type": "number" },
            "type": {
              "type": "string",
              "enum": ["solid", "dashed", "dotted"]
            }
          }
        },
        "label": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" },
            "position": {},
            "formatter": { "type": "string" },
            "fontSize": { "type": "number" },
            "color": { "type": "string" }
          }
        },
        "emphasis": {
          "type": "object",
          "additionalProperties": true
        },
        "markLine": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "silent": { "type": "boolean" },
            "symbol": {},
            "lineStyle": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "color": { "type": "string" },
                "type": {
                  "type": "string",
                  "enum": ["solid", "dashed", "dotted"]
                }
              }
            },
            "data": { "type": "array" },
            "label": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "show": { "type": "boolean" },
                "formatter": { "type": "string" }
              }
            }
          }
        },
        "markPoint": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "symbol": { "type": "string" },
            "symbolSize": { "type": "number" },
            "data": { "type": "array" },
            "label": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "show": { "type": "boolean" },
                "formatter": { "type": "string" }
              }
            },
            "itemStyle": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "color": { "type": "string" }
              }
            }
          }
        },
        "barWidth": {},
        "barGap": { "type": "string" },
        "showSymbol": { "type": "boolean" },
        "symbolSize": {},
        "symbol": { "type": "string" },
        "radius": {},
        "center": {},
        "roseType": {},
        "encode": {
          "type": "object",
          "additionalProperties": true
        },
        "coordinateSystem": { "type": "string" },
        "links": { "type": "array" },
        "categories": { "type": "array" },
        "layout": { "type": "string" },
        "roam": { "type": "boolean" },
        "leaves": {
          "type": "object",
          "additionalProperties": true
        }
      }
    },
    "text_style": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "color": { "type": "string" },
        "fontSize": { "type": "number" },
        "fontWeight": {},
        "fontFamily": { "type": "string" },
        "fontStyle": { "type": "string" }
      }
    },
    "line_style_wrapper": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "lineStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "width": { "type": "number" },
            "type": {
              "type": "string",
              "enum": ["solid", "dashed", "dotted"]
            }
          }
        }
      }
    },
    "visual_map": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["continuous", "piecewise"]
        },
        "min": { "type": "number" },
        "max": { "type": "number" },
        "show": { "type": "boolean" },
        "inRange": {
          "type": "object",
          "additionalProperties": true
        },
        "outOfRange": {
          "type": "object",
          "additionalProperties": true
        }
      }
    },
    "data_zoom": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["slider", "inside", "select"]
        },
        "start": { "type": "number" },
        "end": { "type": "number" },
        "xAxisIndex": {},
        "yAxisIndex": {}
      }
    },
    "toolbox": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "feature": {
          "type": "object",
          "additionalProperties": true
        }
      }
    },
    "radar": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "indicator": { "type": "array" },
        "shape": { "type": "string" },
        "radius": {},
        "center": {},
        "splitNumber": { "type": "number" }
      }
    }
  }
}
